export default class Updater {
  constructor() {
    this.relevantEvents = [];
  }

  addRelevant(eventNamesHash) {
    this.relevantEvents = this.relevantEvents.concat(Object.keys(eventNamesHash).map( key => eventNamesHash[key] ));
  }

  eventOccurred(newState, event) {
    if(this.relevantEvents.indexOf(event.name) > -1) {
      return this.updateState(newState, event);
    } else {
      return newState;
    }
  }

  updateState(state, event) {
    return {};
  }
}


// WEBPACK FOOTER //
// ./src/Services/State/Updaters/Updater.js